import _ from 'lodash';
import { apiSearch, apiFetch, apiRemove } from '../utility';

const apiBase = 'additionalFuelAllocation';
const word = 'additional fuel allocation';

export const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			base : apiBase,
			dispatch,
			callback,
		});
	};
};

export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate : 'additionalFuelAllocationIds',
			params,
			dispatch,
			successMessage : `The ${word} was created successfully. 
				Click continue to return to the ${word} page.`,
			onSuccessRedirectTo : `/inventoryManagement/inventoryAllocations`,
			callback,
		});
	};
};

export const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			successMessage : `The ${word} updated successfully. 
				Click continue to return to the ${word} page.)`,
			onSuccessRedirectTo : `/inventoryManagement/inventoryAllocations`,
			callback,
		});
	};
};

export const remove = ({additionalFuelAllocationId, callback = _.noop}) => {
	return dispatch => {
		apiRemove({
			base : apiBase,
			id : additionalFuelAllocationId,
			dispatch,
			callback,
		});
	};
};
